import { makeStyles } from 'tss-react/mui';

/** Height of one drawn row; the listbox caps itself at a multiple of it. */
export const OPTION_ROW_HEIGHT_PX = 63;

const OPTION_PADDING_Y_PX = 12;
const AVATAR_SIZE_PX = 32;

/**
 * One suggestion row, per the Figma recipients dropdown.
 *
 * The row rules sit behind tripled specificity because both MUI and
 * the theme style options through two-class selectors of their own
 * (`.MuiAutocomplete-listbox .MuiAutocomplete-option` and the theme's
 * popper override); a single class loses to either.
 */
const useStyles = makeStyles()((theme) => ({
  row: {
    '&&&': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.new.spacing.small,
      minHeight: OPTION_ROW_HEIGHT_PX,
      padding: `${OPTION_PADDING_Y_PX}px ${theme.new.spacing.medium}`,
      backgroundColor: 'transparent',
      // The bottom row sits against the paper's own edge, where a
      // divider would read as a doubled border.
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.new.color.line.hairline}`,
      },
      // The design draws one highlight, so pointer hover, the keyboard
      // highlight, and a focus ring all land on the same tint.
      '&:hover, &.Mui-focused, &.Mui-focusVisible, &[aria-selected="true"]': {
        backgroundColor: theme.new.color.brand[100],
      },
    },
  },
  avatar: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: AVATAR_SIZE_PX,
    height: AVATAR_SIZE_PX,
    borderRadius: '50%',
    border: `1px solid ${theme.new.color.line.hairline}`,
    backgroundColor: theme.new.color.background.input,
    color: theme.new.color.textPrimary,
  },
  // Releasing the flex item's automatic minimum is what lets a long
  // address ellipsize instead of widening the row.
  details: {
    minWidth: 0,
  },
  name: {
    display: 'block',
    color: theme.new.color.textPrimary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  email: {
    display: 'block',
    color: theme.new.color.textSecondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
